module.exports = __webpack_public_path__ + "static/media/installerRate.ad329ef7.jpg";